module.exports = __webpack_public_path__ + "static/media/promotion-1.f5480e6c.png";